export default "__VITE_ASSET__BE2Cfqgt__"